import { ChatShell } from "./ChatShell";

const AgentChatPanel = () => {
	return <ChatShell />;
};

export default AgentChatPanel;
